import { Route, Routes } from "react-router-dom";
import { useSetPageTitle } from "../../context/PageTitleContext";
import Videostore from "./videostore";

const VideostoreRoutes = () => {
  useSetPageTitle("Videoteca", "Consulta e gestisci i video didattici");

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 lg:px-8">
      <Routes>
        <Route index element={<Videostore />} />
      </Routes>
    </div>
  );
};

export default VideostoreRoutes;
